import React, { useCallback, useEffect, useState } from "react";
import SnackChip from "../../SnackChip/SnackChip";
import { useTranslation } from "react-i18next";
import { CORE, Category } from "../../../models/SurveyModels";
import images, { getImage, getTemplateImg } from "../../../assets/img/template";
import getClasses from "../../../utils/getClasses";
import { CardLibrary } from "../../CardLibrary/CardLibrary";
import EmptyTable from "../../EmptyTable/EmptyTable";
import {
  getLocalTranslation,
  useComponentVisible,
} from "../../../utils/functions";
import Chevron from "../FormInput/FormSelect/Chevron/Chevron";
import { PopulatedResource } from "../../../models/LibraryModels";
import { useEndpoints } from "../../../hooks/useEndpoints";
require("./FormCreateIssue.scss");
interface IStep3 {
  onChange: (value?: PopulatedResource) => void;
  resource: PopulatedResource;
  arrayFilterSubCategory: Category[];
  selectedRoleFilter?: string;
  selectedFilterCateory?: string;
}

const Step3Issue = ({
  onChange,
  resource,
  arrayFilterSubCategory,
  selectedRoleFilter,
  selectedFilterCateory,
}: IStep3) => {
  const { t } = useTranslation();

  const [libraries, setLibraries] = useState<PopulatedResource[] | undefined>();
  const [filterCategory, setFilterCategory] = useState<
    | ""
    | "ELEARNING"
    | "MICROLEARNING"
    | "CASE_HISTORY"
    | "SUPPORT"
    | "DOCUMENT"
    | "PROJECTS"
  >("");
  const { getAllLibraries } = useEndpoints();
  const [filterSubCategory, setFilterSUbCategory] = useState<
    Category | undefined
  >(
    arrayFilterSubCategory.find(({ id }) => id === selectedFilterCateory) || {
      name: "Tutte le categorie",
      background: "",
      color: "",
      description: "",
      icon: "",
      id: "",
      coreArea: undefined,
    }
  );
  const { ref, setIsComponentVisible, isComponentVisible } =
    useComponentVisible(false);

  const getLibraries = useCallback(() => {
    getAllLibraries({
      role: selectedRoleFilter,
      type: filterCategory,
      category: filterSubCategory?.id,
    }).then((resp) => {
      setLibraries(resp);
    });
  }, [
    filterCategory,
    filterSubCategory?.id,
    getAllLibraries,
    selectedRoleFilter,
  ]);

  useEffect(() => {
    getLibraries();
  }, [getLibraries]);

  return (
    <div className="form-content  library-container questions-container-page step-3 step-3-issue">
      <div className="container__top">
        <div>
          <h1 className="title-page"> {t("createIssue.step3.title")}</h1>
          <div
            className={`container-selected-resource issue-${
              resource ? "with" : "without"
            }-resource mt-4`}
          >
            <i
              className={`icon ${
                resource ? "icon-checkmark" : "icon-book-open"
              }`}
            ></i>
            <p>
              {t(
                `issue.form.${resource ? "with-resource" : "empty-resource"}`,
                {
                  resource:
                    resource?.translations &&
                    getLocalTranslation(resource?.translations).title,
                }
              )}
            </p>
          </div>
        </div>
      </div>
      <div className="container-filters row">
        <div className="col-lg-12 filters-wrapper-snackchip ">
          {(
            [
              "",
              "ELEARNING",
              "MICROLEARNING",
              "CASE_HISTORY",
              "SUPPORT",
              "DOCUMENT",
              "PROJECTS",
            ] as const
          ).map((item, index) => (
            <SnackChip
              key={index}
              filters
              handleCLick={() => {
                setFilterCategory(item);
              }}
              isActive={item === filterCategory}
              theme="filters"
              label={t(`home.library.filters.${item === "" ? "all" : item}`)}
            />
          ))}
        </div>
        <div className="col-lg-4 col-xl-3 justify-content-end">
          <div className="resources-searching container-filters container__top">
            <div ref={ref} className="filter-container col-lg-12 ">
              <div
                className="filter-wrapper col-lg-12"
                onClick={() => {
                  setIsComponentVisible((old) => !old);
                }}
              >
                <span className="language-menu filters-label capitalize-first-letter">
                  {/* {t("home.questions.filterActive")}:{" "} */}
                  <>{filterSubCategory?.name || t(`selectOptions.ALL`)}</>
                </span>
                {filterSubCategory?.name !== "Tutte le categorie" && (
                  <i
                    className="icon-close "
                    onClick={(e) => {
                      e.stopPropagation();
                      setFilterSUbCategory({
                        name: "Tutte le categorie",
                        background: "",
                        color: "",
                        description: "",
                        icon: "",
                        id: "",
                        coreArea: undefined,
                      });
                    }}
                  ></i>
                )}
                <Chevron direction={isComponentVisible ? "top" : "bottom"} />
              </div>
              {isComponentVisible && (
                <div className="switch-filters">
                  {arrayFilterSubCategory.map((item, index) => (
                    <div
                      className={`filters-item ${getClasses({
                        active: item.name === filterSubCategory?.name,
                      })}`}
                      key={index}
                    >
                      <div
                        onClick={() => {
                          setFilterSUbCategory(item);
                          setIsComponentVisible(false);
                        }}
                        className="menu-item d-flex justify-content-between gap-1"
                      >
                        <div>
                          <i
                            style={{
                              color: item.color,
                            }}
                            className={`icon ${item.icon}`}
                          ></i>
                          <span>{item.name}</span>
                        </div>
                        {item.name === filterSubCategory?.name && (
                          <i className="icon icon-checkmark icon-square-checked me-1"></i>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper-images row">
        {libraries && libraries.length > 0 && (
          <div className=" row wrapper-template-items">
            <CardLibrary
              onChangeImage={onChange}
              reosurce={resource}
              resources={libraries || []}
            />
          </div>
        )}
        {libraries?.length === 0 && (
          <EmptyTable
            title={`${t(
              `surveyTemplate.filters.${
                filterCategory === "" ? "all" : filterCategory
              }`
            )}`}
            description={t("surveyTemplate.description")}
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(Step3Issue);
